export const MIN_V1_V2_INTERVAL_DAYS = 28;
export const MIN_V3_V4_INTERVAL_DAYS = 84;